import { Component } from '@angular/core';
import { IncidentType } from '../_types/incident-type';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { IncidentsTypesService } from '../_services/incidents-types.service';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-incidents-types-list',
    templateUrl: './incidents-types-list.component.html',
    styleUrls: ['./incidents-types-list.component.scss'],
    standalone: false
})
export class IncidentsTypesListComponent {
  public incidentTypes: IncidentType[] = [];
  public tabs = [
    { header: 'Operarios', type: 'Worker', emptyMessage: 'No hay tipos de incidencias de operarios' },
    { header: 'Usuarios', type: 'User', emptyMessage: 'No hay tipos de incidencias de usuarios' },
    { header: 'Compañías', type: 'Company', emptyMessage: 'No hay tipos de incidencias de compañías' }
  ];

  public activeIndex: number = 0;
  public totalRecords: number = 0;
  public loading: boolean = false;
  public lastGridEvent: any;
  public filters: any = {
    name: new Filter(FilterOperation.contains, 'name'),
  };
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;

  constructor(
    private incidentsTypesService: IncidentsTypesService,
    private topbarService: TopbarService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private messageService: MessageService
  ) {
   
  }

  ngOnInit(): void {
    this.topbarService.setTitle("Tipos de incidencias");
    this.topbarService.addAction("Nuevo", "pi pi-plus", false, () => {
      this.edit({} as IncidentType);
    });
    this.allowWrite = true;//this.loginService.hasPermission("INCIDENTS.WRITE")
    this.allowDelete = true;//this.loginService.hasPermission("INCIDENTS.DELETE")
  }

  public async loadData($event: any) {
    this.lastGridEvent = $event;

    let params: IParamsCollection = {
      page: { number: $event.first + 1, size: $event.rows }
    }

    if (typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];

    // filtro según activeIndex
    if (this.activeIndex == 0) {
      this.filters.source = new Filter(FilterOperation.equals, 'source', '', 'Worker')
    } else if (this.activeIndex == 1) {
      this.filters.source = new Filter(FilterOperation.equals, 'source', '', 'User')
    } else if (this.activeIndex == 2) {
      this.filters.source = new Filter(FilterOperation.equals, 'source', '', 'Company')
    }

    //creamos filtros
    params.filter = FilterBuilder.fromObject(this.filters).build();

    let response = await firstValueFrom(this.incidentsTypesService.all(params));
    this.incidentTypes = response.data;
    this.totalRecords = response.meta['total'];
    this.topbarService.setCount(this.totalRecords);
  }

  clearFilters() {
    this.filters = {};
    this.search();
  }

  search() {
    this.lastGridEvent.first = 0;
    this.loadData(this.lastGridEvent);
  }

  edit(incidentType: IncidentType | null, source?: string) {
    this.router.navigate(['incidentsTypes/' + (incidentType && Object.keys(incidentType).length > 0 ? incidentType.id : 0) + (source ? '/' + source : '')]);
  }

  delete(incidentType: any) {
    if (this.allowDelete) {
      this.confirmationService.confirm({
        message: "¿Está seguro que desea eliminar el tipo de incidencia?",
        header: "Eliminar tipo de incidencia",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.incidentsTypesService.delete(incidentType.id).subscribe({
            next: (data: any) => {
              this.messageService.add({ closable: true, severity: 'success', detail: "Tipo de incidencia eliminado correctamente" });
              this.loadData(this.lastGridEvent);
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        }
      });
    }
  }
}
